module.exports = __webpack_public_path__ + "static/media/breakout&fanout_assemblies.71a91a84.jpg";